import type { SVGProps } from "react";

export function IconDarkPurpleMoneybagDollar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6191_13053)">
        <path
          d="M12.375 9.625L5.76427 16.7442C1.47528 21.3632 4.75097 28.875 11.0541 28.875H21.9459C28.249 28.875 31.5247 21.3632 27.2357 16.7442L20.625 9.625M12.375 9.625L9.28125 4.125H23.7188L20.625 9.625M12.375 9.625H20.625M16.5 15.125V12.7188M16.5 25.7812V23.375M13.4062 21.3125C13.4062 21.7204 13.5877 22.1192 13.9276 22.4584C14.2676 22.7975 14.7508 23.0619 15.3161 23.218C15.8814 23.3741 16.5034 23.415 17.1036 23.3354C17.7037 23.2558 18.2549 23.0594 18.6876 22.7709C19.1203 22.4825 19.4149 22.115 19.5343 21.7149C19.6537 21.3148 19.5924 20.9001 19.3583 20.5232C19.1241 20.1463 18.7276 19.8242 18.2188 19.5976C17.71 19.371 17.1119 19.25 16.5 19.25C15.8881 19.25 15.29 19.129 14.7812 18.9024C14.2724 18.6758 13.8759 18.3537 13.6417 17.9768C13.4076 17.5999 13.3463 17.1852 13.4657 16.7851C13.5851 16.385 13.8797 16.0175 14.3124 15.7291C14.7451 15.4406 15.2963 15.2442 15.8964 15.1646C16.4966 15.085 17.1186 15.1259 17.6839 15.282C18.2492 15.4381 18.7324 15.7025 19.0724 16.0416C19.4123 16.3808 19.5938 16.7796 19.5938 17.1875"
          stroke="#3E2247"
          strokeWidth="2.0625"
        />
      </g>
      <defs>
        <clipPath id="clip0_6191_13053">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
